import { queryClient } from '../queryClient'
import { QUERY_CURRENT_USER } from '../queryKeys/currentUser'

const currentUserSelector = () => queryClient.getQueryData(QUERY_CURRENT_USER)

export default currentUserSelector
